import type { FunctionComponent } from "react"

import Script from "next/script"

type WonderchatScriptProps = {
  wonderchatKey: string
}

export const WonderchatScript: FunctionComponent<WonderchatScriptProps> = ({ wonderchatKey }) => {
  return (
    <Script
      src="https://app.wonderchat.io/scripts/wonderchat.js"
      data-name="wonderchat"
      data-address="app.wonderchat.io"
      data-id={wonderchatKey}
      data-widget-size="normal"
      data-widget-button-size="normal"
      data-placement="left"
      defer
    />
  )
}
